import { filterValueToQuery } from '@/api';

export default function lot(axios: any) {
  async function getLots(filter: any) {
    try {
      const response = await axios.get(`/api/lots?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/lot] getLots Error', e);
    }
    return null;
  }

  async function getLot(id: number) {
    const response = await axios.get(`/api/lots/${id}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/lot] updateLot Error', e);
    }
    return null;
  }

  async function deleteLot(id: number) {
    const response = await axios.delete(`/api/lots/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/lot] deleteLot Error', e);
    }
    return null;
  }

  return {
    getLots,
    getLot,
    deleteLot,
  };
}
